import { useState } from "react";
import { useParams } from "react-router-dom";
import api from './../../api/api';
import { Oval } from "react-loader-spinner";
import Confirm from "../Modal/Alert/confirm";

const EnvoyerMail = () =>{
    
    const {email, name} = useParams();

    console.log(email, name)

    const [body, setBody] = useState(null);
    const [title, setTitle] = useState(null)
    const [loading, setLoading] = useState(false)
    const [showAlert, setShowAlert] = useState(false)


    const sendEmail = async ()=>{

        if(body && email && title){
            
            try {
    
                setLoading(true)
                const a = await api.post('/email/create', {
                    body, email, title
                })
    
                console.warn(a)
                setLoading(false)

                return;
                
            } catch (error) {
                console.log(error)
            }
        }else{
            
        }
    }


    return (
        <div className="p-5 m-10 bg-white rounded-lg dark:bg-gray-800">
          <form>
            <h3 className="mb-4 text-2xl font-bold dark:text-gray-200">{name}</h3>
            <label className="block mb-2 dark:text-gray-200">À :</label>
            <input
              type="email"
              value={email}
              className="w-full p-2 mb-4 border border-gray-300 rounded dark:text-gray-200 dark:bg-gray-700 dark:border-gray-600"
              placeholder="Email du propriétaire"
              readOnly
            />

            <label className="block mb-2 dark:text-gray-200">Titre :</label>
            <input
              type="text"
              value={title}
              onChange={(event)=>setTitle(event.target.value)}
              className="w-full p-2 mb-4 border border-gray-300 rounded dark:text-gray-200 dark:bg-gray-700 dark:border-gray-600"
              placeholder="Titre"
            />
            
            <label className="block mb-2 dark:text-gray-200">Message :</label>
            <textarea
              className="w-full p-2 mb-4 border border-gray-300 rounded dark:text-gray-200 dark:bg-gray-700 dark:border-gray-600"
              rows="5"
              
              onChange={(event)=>setBody(event.target.value)}
              placeholder="Écrire un message"
            />
            {!loading ?
                <div onClick={()=>setShowAlert(true)} className="items-center self-center justify-center w-full py-2 text-center text-white bg-indigo-700 rounded-md cursor-pointer hover:bg-indigo-800">
                    <p className="dark:text-gray-200">Envoyer</p>
                </div>
              :
              <div className="flex items-center self-center justify-center m-auto text-center">
                  <Oval
                      height={20}
                      width={20}
                      color="blue"
                      visible={true}
                      ariaLabel="oval-loading"
                      secondaryColor="#cccccc"
                      strokeWidth={2}
                      strokeWidthSecondary={2}
                  />
              </div>}

              <Confirm
                open={showAlert}
                onClose={()=>setShowAlert(false)}
                onAccept={sendEmail}
                onDecline={()=>setShowAlert(false)}
                message={'Voulez vous vraiment envoyer cet email'}
              />

          </form>

          
          
        </div>
      );
} 


export default EnvoyerMail
